// src/services/Post-service.js
import api from "@/services/api";

export default {
  async getPosts() {
    return await api.get("/posts");
  },

  async createPost1(userData) {
    return await api.post("/posts", userData);
  },

  async createPost(userData) {
    return await api.post("/posts", userData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async updatePost(id, userData) {
    return await api.post(`/posts/${id}`, userData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async getPostById(id) {
    return await api.get(`/posts/${id}`);
  },

  async publishPost(id) {
    return await api.patch(`/posts/${id}`);
  },

  async deletePost(id) {
    return await api.delete(`/posts/${id}`);
  },

  async addPostcomment(postId, data) {
    return await api.post(`/posts/comments/${postId}`, data);
  },

  async editPostcomment(commentId, data) {
    return await api.put(`/posts/comments/${commentId}`, data);
  },

  async deletePostcomment(commentId) {
    return await api.delete(`/posts/comments/${commentId}`);
  },
};
